import { createListQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'

export const usePrevalenceUnit = createSharedComposable(() => {
    const { t } = useI18n()

    return createListQuery('prevalence-unit', () => [
        {
            label: t('per-thousand-people'),
            value: 'per-thousand'
        },
        {
            label: t('absolute-estimated-number'),
            value: 'absolute'
        }
    ])
})
